export default {
  namespaced: true,
  state: {
    loginConfig: {
      backgroundImg: require("@/assets/PC/loginBg.png"),
      themeColor: "#0F3CC6",
      logo: require("@/assets/PC/yilinlogo.png"),
      footerColor: "#EAEAFF",
      footerlineColor: "#EAEAFF",
    },
    pmloginCongih: {
      backgroundImg: require("@/assets/PC/pmlogin/pm-bg.png"),
      themeColor: "#3264A0",
      logo: require("@/assets/PC/pmlogin/pm-logo.png"),
      footerColor: "#333333",
      footerlineColor: "#B1B1B3",
    },
  },
  getters: {
    getLoginConfig: (state) => {
      if (sessionStorage.getItem("_big_origin") === "THEME_PM") {
        return state.pmloginCongih;
      } else {
        return state.loginConfig;
      }
    },
  },
  mutations: {
    setLoginConfig(state, value) {
      // 设置登录页主题
      state.loginConfig = value;
    },
  },
};
